/**
 * 推送广告表请求接口
 * @author 王振宇
 * @since 2022-05-02
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_PUSHADVERTISEMENT_PAGE_LIST: function GET_PUSHADVERTISEMENT_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushAdvertisement/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_PUSHADVERTISEMENT_LIST: function GET_PUSHADVERTISEMENT_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushAdvertisement/getList',
        method: 'get',
        params: data
      });
    },
    GET_PUSHADVERTISEMENT_INFO: function GET_PUSHADVERTISEMENT_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushAdvertisement/info',
        method: 'get',
        params: data
      });
    },
    SAVE_PUSHADVERTISEMENT: function SAVE_PUSHADVERTISEMENT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushAdvertisement/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_PUSHADVERTISEMENT: function UPDATE_PUSHADVERTISEMENT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushAdvertisement/update',
        method: 'put',
        data: data
      });
    },
    DELETE_PUSHADVERTISEMENT: function DELETE_PUSHADVERTISEMENT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushAdvertisement/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_PUSHADVERTISEMENT: function DELETE_BATCH_PUSHADVERTISEMENT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushAdvertisement/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});